import accounting from 'accounting';

export const moneyKeys = ['cost_total', 'ecpm', 'acp'];
export const thousandsKeys = [
  'cost_total',
  'ecpm',
  'acp',
  'request',
  'impression_total',
  'click_total',
  'served_account_num',
  'served_request',
];
export const percentKeys = ['filled_rate', 'ctr'];

export function formatValue(key, value) {
  if (isIncreasePercent(key)) {
    return value;
  }

  if (thousandsKeys.includes(key)) {
    if (moneyKeys.includes(key)) {
      return accounting.formatMoney(value, '￥');
    }
    return accounting.formatNumber(value);
  } else if (percentKeys.includes(key)) {
    return `${value}%`;
  }

  return value;
}

export function isIncreasePercent(key) {
  return key === '涨幅百分比';
}
